import { render, staticRenderFns } from "./DailyScoreCollarStatusDetail.vue?vue&type=template&id=1191b5ea&"
import script from "./DailyScoreCollarStatusDetail.vue?vue&type=script&lang=js&"
export * from "./DailyScoreCollarStatusDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports